import * as c from '../constants/actionTypes';

let initialState = {
  paper : {
    editor_level: 'gold',
    word_count: 500,
    doc_name: false,
    doc_cost: 0,
    time_limit: 7,
    extras: []
  },
  emails_match: false,
  coupon_code: '',
  coupon_amount: 0,
  is_affiliate_code: false,
  usingBalance: false,
  balanceUsed: 0,
  terms_accepted: false,
  fullAddress: false,
  pricing: {
    bronze: [],
    silver: [],
    gold: [],
    pro: []
  },
  newUserPass: ''
}

export default (state = initialState, action) => {
  switch (action.type) {
    case c.TERMS_CHECKED:
      var newState = state;
      newState.terms_accepted = !action.body;
      return state = Object.assign({}, state, newState);
    case c.UPDATE_COUPON_CODE:
      var newState = state;
      newState.coupon_code = action.body;
      return state = Object.assign({}, state, newState);
    case c.CHECK_COUPON_SUCCESS:
      var newState = state;
      newState.coupon_amount = action.body.coupon.coupon_amount;
      newState.is_affiliate_code = action.body.coupon.is_affiliate;
      return state = Object.assign({}, state, newState);
    case c.CHECK_COUPON_FAILURE:
      var newState = state;
      // zero coupon amount on a rejected coupon
      newState.coupon_amount = 0;
      newState.is_affiliate_code = false;
      return state = Object.assign({}, state, newState);
    case c.UPDATE_BALANCE_USED:
      var newState = state;
      newState.balanceUsed = action.body;
      newState.usingBalance = (action.body>0);
      return state = Object.assign({}, state, newState);
    case c.BOTH_EMAILS_MATCH:
      var newState = state;
      newState.emails_match = true;
      return state = Object.assign({}, state, newState);
    case c.BOTH_EMAILS_DONT_MATCH:
      var newState = state;
      newState.emails_match = false;
      return state = Object.assign({}, state, newState);
    case c.UPDATE_PAPER_INPUT:
      var newState = state;
      newState.paper[action.key] = action.body;
      if(newState.paper.country && newState.paper.address && newState.paper.zip_code) {
        newState.fullAddress = true;
      } else {
        newState.fullAddress = false;
      }
      return state = Object.assign({}, state, newState);
    case c.UPDATE_STEP_2:
      var newState = state;
      newState.paper.time_limit = action.time_limit;
      newState.paper.editor_level = action.editor_level;
      return Object.assign({}, state, newState);
    case c.UPSELL_EDITOR_LEVEL:
      var newState = state;
      newState.paper.editor_level = action.editor_level;
      return Object.assign({}, state, newState);
    case c.UPSELL_TIME_LIMIT:
      var newState = state;
      newState.paper.time_limit = action.time_limit;
      return Object.assign({}, state, newState);
    case c.UPDATE_STEP_3_SUMMARY:
      var newState = state;
       if(action.extras_array.indexOf(action.extra) > -1){
        var index = action.extras_array.indexOf(action.extra);
        action.extras_array.splice(index, 1);
      }else{
        newState.paper.extras.push(action.extra);
      }
      return Object.assign({}, state, newState);
    case c.UPDATE_STEP_3_SPECIAL_TEXT:
      var newState = state;
      newState.paper.special_instructions = action.special_text;
      return Object.assign({}, state, newState);
    case c.UPDATE_STEP_3_UPLOAD:
      var newState = state;
      newState.paper.special_instructions_file = action.file_name;
      return Object.assign({}, state, newState);
    case c.REMOVE_EXTRA:
      var newState = state;
      var index = action.extras_array.indexOf(action.extra);
      action.extras_array.splice(index, 1);
      newState.extras = action.extras_array;
      return Object.assign({}, state, newState);
    case c.UPLOAD_PAPER_REQUEST:
      return state = Object.assign({}, state, {
        loading: action.loading,
        paperLoading: action.loading
      })
    case c.UPLOAD_PAPER_SUCCESS:
      var newState = state;
      newState.paper.doc_name = action.body.data.doc_name;
      newState.paper.word_count = action.body.data.word_count;
      return Object.assign({}, state, newState);
    case c.UPLOAD_PAPER_FAILURE:
      return state;
    case c.GET_PAPER:
      var newState = state
      return state = Object.assign({}, state, {
          paper: action.body
      })
    case c.GET_PRICING_REQUEST:
      return state = Object.assign({}, state, {
        loading: action.loading
      })
    case c.GET_PRICING_SUCCESS:
      return state = Object.assign({}, state, {
        loading: action.loading,
        pricing: action.body
      })
    case c.GET_PRICING_FAILURE:
      return state = Object.assign({}, state, {
        loading: action.loading,
        error: action.error
      })
    case 'POST_PAYSTRIPE_SUCCESS':
    case 'AUTHORIZED_PAYPAL':
      if(action.body.userdata && action.body.userdata.password) {
        return state = Object.assign({}, state, {
          newUserPass: action.body.userdata.password
        });  
      } else {
        return state;
      }
    default:
      return state
  }
}

// var extras_array = ["gradeMyPaper",
//                     "Plagiarism",
//                     ,"CitationCorrection"
//                     ,"Formatting"
//                     ,"Critiques"
//                     ,"extraComments"
//                     ,"ExtraEditing"
//                     ,"ESL"];
// for (var i = 0; i < extras_array.length; i++) {
//   if(this.props.Paper.paper.extras.indexOf(extras_array[i]) > -1){
//     console.log("extra found, ", extras_array[i]);
//   }
// }



// WEBPACK FOOTER //
// ./src/reducers/Pay.js